import { createSuitMixin as t } from "../mixins/suit.js";
import "../util/vue-compat/index-vue2.js";
import { createPanelProviderMixin as i } from "../mixins/panel.js";
export default {
  name: "AisPanel",
  mixins: [t({
    name: "Panel"
  }), i()],
  methods: {
    getSlot: function getSlot(t) {
      return this.$slots[t] || this.$scopedSlots[t];
    }
  }
};